import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  Avatar,
} from "@mui/material";
import { UseHomeSlides } from "./UseHomeSlides";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../../components/ProgressCom";
import Detail from "../../../main/detail/Detail";
import { useRecoilState } from "recoil";
import { rsProgress, rsActiveMenu, rsParentCom } from "../../../RecoilStates";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function EditSlide(props) {
  const { toSolar } = require("jdate-convert");
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const { GetHomeSlideById, validate, updateSlide } = UseHomeSlides();
  const [imgState, setImgState] = useState({
    file1: undefined,
    url1: undefined,
    file2: undefined,
    url2: undefined,
  });
  const [valueStart, setValueStart] = useState();
  const [valueEnd, setValueEnd] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const [state, setState] = useState({
    id: location.state.oneSlideID,
    aid: undefined,
    title: undefined,
    url: undefined,
    isFix: false,
    isSide: false,
    isActive: false,
    rowIndex: undefined,
    startDate: undefined,
    endDate: undefined,
  });
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    setProgress(true);
    GetHomeSlideById(location.state.oneSlideID, (slide) => {
      setImgState({ ...imgState, url1: slide.image1, url2: slide.image2 });
      setState({
        id: slide.id,
        aid: slide.aid,
        title: slide.title,
        url: slide.url,
        isFix: slide.isFix,
        isSide: slide.isSide ? slide.isSide : false,
        isActive: slide.isActive,
        rowIndex: slide.rowIndex,
        startDate: slide.startDate ? slide.startDate : "",
        endDate: slide.endDate ? slide.endDate : "",
      });
    });
  }, []);

  const [errorState, setErrorState] = useState({
    title: false,
    url: false,
    file1: false,
    file2: false,
  });

  const handleChangeImage1 = (e) => {
    setImgState({
      ...imgState,
      file1: e.target.files[0],
      url1: URL.createObjectURL(e.target.files[0]),
    });
  };

  const handleChangeImage2 = (e) => {
    setImgState({
      ...imgState,
      file2: e.target.files[0],
      url2: URL.createObjectURL(e.target.files[0]),
    });
  };

  useEffect(() => {
    let newValueStart = valueStart?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setState({ ...state, startDate: newValueStart });
  }, [valueStart]);

  useEffect(() => {
    let newValueEnd = valueEnd?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    setState({ ...state, endDate: newValueEnd });
  }, [valueEnd]);

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/SlidesManage",
            SlideID: location.state.SlideID,
            componentFaTitle: location.state.componentFaTitle,
          },
          {
            name: "ویرایش اسلاید",
            url: "/SlidesManage/editSlide",
          },
        ],
      }}
    >
      {state ? (
        <Box display="grid" gap={3}>
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
            <Box gridColumn={isSmall ? "span 12" : "span 3"}>
              <TextField
                fullWidth
                value={state.title ? state.title : ""}
                error={errorState.title}
                label="عنوان"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, title: evt.target.value });
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            {!isSmall && <Box gridColumn="span 9"></Box>}
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                value={state.url ? state.url : ""}
                error={errorState.url}
                label="آدرس"
                sx={{
                  textarea: {
                    direction: "rtl",
                  },
                }}
                multiline
                rows={2}
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, url: evt.target.value });
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            {!isSmall && <Box gridColumn="span 6"></Box>}

            <Box
              gridColumn={isSmall ? "span 12" : "span 7"}
              sx={{
                display: "flex",
                flexDirection: isSmall ? "column" : "row",
                alignItems: isSmall ? "flex-start" : "center",
                gap: 5,
              }}
            >
              <Box component="label">
                <Avatar
                  sx={{
                    border: "1px solid #d9d9d9",
                    borderRadius: 3,
                    width: "100%",
                    height: "150px",
                    p: 1,
                  }}
                  src={
                    imgState.url1 ? imgState.url1 : "/static/img/nobanner.jpg"
                  }
                  alt="img"
                />
                <input
                  type="file"
                  id="img"
                  name="avatarName"
                  accept="image/*"
                  multiple
                  onChange={handleChangeImage1}
                  hidden
                />
              </Box>
              <Box component="label">
                <Avatar
                  sx={{
                    border: "1px solid #d9d9d9",
                    borderRadius: 3,
                    width: "100%",
                    height: "150px",
                    p: 1,
                  }}
                  src={
                    imgState.url2 ? imgState.url2 : "/static/img/nobanner.png"
                  }
                  alt="img"
                />
                <input
                  type="file"
                  id="img"
                  name="avatarName"
                  accept="image/*"
                  multiple
                  onChange={handleChangeImage2}
                  hidden
                />
              </Box>
            </Box>
            {!isSmall && <Box gridColumn="span 5"></Box>}
            <Box
              sx={{ display: "flex", gap: 2 }}
              gridColumn={isSmall ? "span 12" : "span 7"}
            >
              <DatePicker
                weekDays={weekDays}
                calendar={persian}
                locale={persian_fa}
                format="YYYY-MM-DD"
                onChange={setValueStart}
                value={state && state.startDate ? toSolar(state.startDate) : ""}
                render={
                  <TextField
                    sx={{ pr: 2, input: { textAlign: "center" } }}
                    variant="outlined"
                    size="small"
                    fullWidth
                    label="تاریخ شروع"
                  />
                }
              />
              <DatePicker
                weekDays={weekDays}
                calendar={persian}
                locale={persian_fa}
                format="YYYY-MM-DD"
                value={state && state.endDate ? toSolar(state.endDate) : ""}
                // value={valueEnd}
                onChange={setValueEnd}
                render={
                  <TextField
                    sx={{ input: { textAlign: "center" } }}
                    variant="outlined"
                    label="تاریخ پایان"
                    size="small"
                    fullWidth
                  />
                }
              />
            </Box>
            {!isSmall && <Box gridColumn="span 5"></Box>}
            <Box gridColumn={isSmall ? "span 12" : "span 3"}>
              <FormControlLabel
                checked={state.isFix}
                onChange={(evt) => {
                  setState({ ...state, isFix: evt.target.checked });
                }}
                control={<Checkbox />}
                label=" جایگاه نمایش ثابت شود "
              />
            </Box>
            {(location.state?.ComponentID == 14 ||
              location.state?.ComponentID == 45) && (
              <Box gridColumn={isSmall ? "span 12" : "span 3"}>
                <FormControlLabel
                  checked={state.isSide}
                  onChange={(evt) => {
                    setState({ ...state, isSide: evt.target.checked });
                  }}
                  control={<Checkbox />}
                  label="اسلاید کناری"
                />
              </Box>
            )}
            {!isSmall && <Box gridColumn="span 6"></Box>}
            <Box
              gridColumn={isSmall ? "span 12" : "span 6"}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                sx={{ mr: 2, width: "70px" }}
                variant="contained"
                onClick={() => {
                  if (validate(state, imgState, setErrorState) == 200) {
                    var landingModel = state;
                    if (msParentCom.landingPageID) {
                      landingModel = {
                        landingId: msParentCom.landingPageID,
                        aid: location.state.SlideID,
                        title: state.title,
                        url: state.url,
                        isFix: state.isFix,
                        isSide: state.isSide,
                        startDate: state.startDate,
                        endDate: state.endDate,
                      };
                    }
                    setProgress(true);
                    updateSlide(state, imgState.file1, imgState.file2, () => {
                      navigate("/SlidesManage", {
                        state: { ...location.state, isBack: true },
                        replace: true,
                      });
                    });
                  }
                }}
              >
                ثبت
              </Button>
              <Button
                sx={{ width: "70px" }}
                variant="outlined"
                onClick={() => {
                  navigate("/SlidesManage", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                }}
              >
                بازگشت
              </Button>
            </Box>
            {!isSmall && <Box gridColumn="span 9"></Box>}
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
